<template>
  <div
    :class="[$style.root, viewOptionClassString]"
  >
    <CoreTextComponent
      :string="string"
      :class="$style.text"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  block: Object,
  withinModal: {
    type: Boolean,
    default: false,
  }
})

const string = computed(() => i18nGetLocalizedString(props?.block, 'i18n_richtext_en'))


const viewOptionClassString = computed(() => {
  switch (i18nGetLocalizedData(props?.block)?.view_option)
  {
    case 'large':
      return 'font-size-medium'
    case 'small':
    case 'indented':
    case 'note':
      return 'font-size-small'
    default:
      return 'font-size-default'
  }
})

const withinModalClassString = computed(() => {
  return !props?.withinModal ? 'container--default' : ''
})
</script>

<style module lang="scss">
.root {
  composes: container--default from global;
}
</style>
